import React from 'react';
import { Layout, Typography, Space, Divider } from 'antd';
import { TenantContext } from '../../types';

const { Footer } = Layout;
const { Text, Link } = Typography;

interface TenantFooterProps {
  tenant: TenantContext;
}

export const TenantFooter: React.FC<TenantFooterProps> = ({ tenant }) => {
  return (
    <Footer
      style={{
        textAlign: 'center',
        background: '#f0f2f5',
        borderTop: '1px solid #d9d9d9',
      }}
    >
      <Space split={<Divider type="vertical" />} size="middle">
        <Text type="secondary">
          © {new Date().getFullYear()} {tenant.organization?.name}
        </Text>
        
        <Text type="secondary">
          Mantik Platform
        </Text>
        
        {tenant.branding?.custom_domain && (
          <Link
            href={`https://${tenant.branding.custom_domain}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {tenant.branding.custom_domain}
          </Link>
        )}
        
        <Text type="secondary">
          Subscription: {tenant.organization?.subscription_tier}
        </Text>
      </Space>
      
      <div style={{ marginTop: 8 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Built with ❤️ for event management
        </Text>
      </div>
    </Footer>
  );
};